import React from 'react';

const Icon = () => {
    return (
        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 6.00024H21" stroke="#737FA4" strokeWidth="1.4" strokeLinejoin="round" />
            <rect x="0.7" y="0.700244" width="19.6" height="16.6" rx="3.3" stroke="#737FA4" strokeWidth="1.4" strokeLinecap="round" />
            <path d="M4.7998 9.60034H8.11339" stroke="#737FA4" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.7998 13.7334H13.0838" stroke="#737FA4" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default Icon;


